import merge from 'lodash/merge';

export default function contentReducer(state = {}, action) {
  if (
    action.meta &&
    action.meta.content &&
    action.payload &&
    action.payload.entities
  ) {
    return merge({}, state, action.payload.entities);
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/store/content/reducer.js